import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-modal-provider-site',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-provider-site.component.html',
  styleUrl: './modal-provider-site.component.css'
})
export class ModalProviderSiteComponent {
  @Input() showModal: boolean = false;
  @Input() title: string = 'เลือกผู้ให้บริการลานจอด';
  @Input() placeholder: string = 'ค้นหาชื่อผู้ให้บริการ...';
  @Input() dataList: any[] = []; // รองรับข้อมูลหลายรูปแบบ

  @Output() showModalChange = new EventEmitter<boolean>();
  @Output() itemSelected = new EventEmitter<any>();

  searchQuery: string = '';

  get filteredData(): any[] {
    if (!this.searchQuery) return this.dataList;
    return this.dataList.filter((item) =>
      (item.name && item.name.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
      (item.address && item.address.toLowerCase().includes(this.searchQuery.toLowerCase()))
    );
  }

  closeModal() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }

  selectItem(item: any) {
    this.itemSelected.emit(item);
    this.closeModal();
  }
}
